export const LOANS_STATUS = {
  QUEUED: 'Queued',
  REFUSED: 'Refused',
  APPROVED: 'Approved',
  ACCEPTED: 'Accepted',
  FAILED: 'Failed',
  PREAPPROVED: 'PreApproved',
  ISSUED: 'Issued',
} as const;

export const OFFER_STATUS = {
  NEW: 'new',
  QUEUED: 'queued',
  ALREADY_SENT_FROM_SAME_BANK: 'alreadySentFromSameBank',
  REFUSED: 'refused',
  APPROVED: 'approved',
  ACCEPTED: 'accepted',
  FAILED: 'failed',
  PREAPPROVED: 'preapproved',
  ISSUED: 'issued',
} as const;

export type TOfferStatus = (typeof OFFER_STATUS)[keyof typeof OFFER_STATUS];
export type TLoansStatus = (typeof LOANS_STATUS)[keyof typeof LOANS_STATUS];

export const RESTRICTION_FLAGS = {
  RED_PROMO_INSURANCE_LIFE: 'RED_PROMO_INSURANCE_LIFE',
  EXACT_CONDITION_OFFER: 'EXACT_CONDITION_OFFER',
  WITH_CAR_NUMBER_ONLY: 'WITH_CAR_NUMBER_ONLY',
} as const;
